// extracted by mini-css-extract-plugin
module.exports = {"separator":"Separator_separator__X_pwU","separatorLine":"Separator_separatorLine__Z4pzV","separatorText":"Separator_separatorText__B_AtQ"};